import { render } from "./AddFarmerModal4.vue?vue&type=template&id=2a3c1818&scoped=true"
import script from "./AddFarmerModal4.vue?vue&type=script&lang=js"
export * from "./AddFarmerModal4.vue?vue&type=script&lang=js"

import "./AddFarmerModal4.vue?vue&type=style&index=0&id=2a3c1818&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3c1818"]])

export default __exports__